import { subscribeOnAuthentification } from './subscribeOnAuthentification';
import { IRequestAuthenticationParameters } from './types';

import type { IThunkActionCreator } from '../../store';

export function requestAuthentication(parameters?: IRequestAuthenticationParameters): IThunkActionCreator {
  return (dispatch, _getState, context) => {
    /* istanbul ignore else */
    if (typeof window !== 'undefined') {
      dispatch(subscribeOnAuthentification(parameters));

      void context.microfrontendsAPI?.header.openAuthModal({
        autoRefresh: !parameters?.onSuccess,
        alert: parameters?.alert ?? null,
        useDefaultView: false,
        viewData: parameters?.viewData ?? null,
        source: parameters?.source ?? null,
      });
    }
  };
}
